import type { ThemeConfig } from "../types";
import { Mascot, unicornLandDecorations } from "./decorations";
import { UnicornLandScene } from "./Scene";

export const unicornLand: ThemeConfig = {
  id: "unicorn-land",
  name: "Unicorn Land",
  tagline: "Dreamy glass meadow, cosmic rainbow, polished unicorn",
  brandLabel: "Unicorn Land",
  tokens: {
    bg: "#09051c",
    bgElevated: "rgba(255, 255, 255, 0.08)",
    bgPanel: "rgba(14, 8, 35, 0.78)",
    bgOverlay: "rgba(6, 2, 22, 0.82)",

    fg: "#ffffff",
    fgMuted: "rgba(245, 237, 255, 0.66)",
    fgStrong: "#fff7ff",
    fgInverse: "#0a0a0a",

    accent: "#ffe779",
    accentSoft: "rgba(255, 231, 121, 0.16)",
    accent2: "#ff7adf",
    accent2Soft: "rgba(255, 122, 223, 0.18)",
    accentRainbow:
      "linear-gradient(90deg, #ff7adf, #ffb36d, #ffe779, #8dffb5, #78f4ff, #b58cff, #ff7adf)",

    border: "rgba(255, 255, 255, 0.15)",
    borderSoft: "rgba(255, 255, 255, 0.1)",
    borderStrong: "rgba(255, 231, 121, 0.42)",

    positive: "#8dffb5",
    negative: "#ff5da8",
    warning: "#ffb36d",

    bankPanelBg:
      "linear-gradient(155deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.055)), rgba(13, 7, 34, 0.76)",
    bankPanelBorder: "rgba(255, 255, 255, 0.18)",
    bankPanelHeading: "#ffbdf0",

    fontDisplay: "'Barlow Condensed', 'Inter', system-ui, sans-serif",
    fontBody: "'Barlow', 'Inter', system-ui, sans-serif",
    fontMono: "'DM Mono', 'Menlo', ui-monospace, monospace",

    decorationGlow: "0 24px 80px rgba(0, 0, 0, 0.32), 0 0 36px rgba(255, 122, 223, 0.18)"
  },
  assets: {
    mascot: "/assets/unicorn-land-mascot.png",
    decorations: unicornLandDecorations(),
    Scene: UnicornLandScene
  }
};

// Re-exported so the gumballs page can render the mascot as a regular React
// component without going through the decoration list.
export { Mascot };
